import React from 'react';
import { amountFormatter } from '/src/lib/helpers';
import { computeExitRateMeta } from '/src/components/ICESections/Shared/helpers';
import Highlights from '/src/components/Reusable/Highlights/Highlights';

const CARD_CONFIG = [
    {
        key: 'medianCheckSize',
        label: 'Median Check Size',
        metaKey: 'medianCheckSizeMeta',
    },
    {
        key: 'followOnRate',
        label: 'Follow-On Rate',
        metaKey: 'followOnRateMeta',
    },
    {
        key: 'capitalDeployed',
        label: 'Est. Capital Deployed',
        metaKey: 'capitalDeployedMeta',
    },
    {
        key: 'exitsFromFund',
        label: 'Exits from Fund',
        metaKey: 'exitsFromFundMeta',
    },
    {
        key: 'stillActive',
        label: '% Still Active',
        metaKey: 'stillActiveMeta',
    },
];


const computeStillActiveMeta = (stillActivePercentage, totalPortfolioCompanies) => {
    if (!stillActivePercentage || !totalPortfolioCompanies) return ' ';
    const pct = parseFloat(stillActivePercentage);
    if (Number.isNaN(pct)) return ' ';
    const activeCount = Math.round((pct / 100) * totalPortfolioCompanies);
    return `${activeCount} of ${totalPortfolioCompanies} companies`;
};

const InvestmentSummaryCards = (props) => {
    const {
        allStageInvestmentsCount,
        allStageRoundsCount,
        followOnInvestmentsCount,
        followOnRatePercentage,
        medianCheckSize,
        capitalDeployed,
        pctDeployed,
        exitsFromFund,
        stillActivePercentage,
        totalPortfolioCompanies,
    } = props?.investmentStats || {};

    const stats = {
        medianCheckSize: medianCheckSize ? amountFormatter(medianCheckSize) : 'N/A',
        medianCheckSizeMeta: 'Across deals',
        followOnRate: followOnRatePercentage || 'N/A',
        followOnRateMeta: followOnInvestmentsCount
            // follow-ons and the rate count rounds; the row count is only a fallback for an API without all_stage_rounds_count
            ? `${followOnInvestmentsCount} of ${allStageRoundsCount ?? allStageInvestmentsCount} are follow-ons`
            : 'No follow-on data',
        capitalDeployed: capitalDeployed || 'N/A',
        capitalDeployedMeta: Math.round(pctDeployed) > 0 ? `${Math.round(pctDeployed)}% est. capital deployed` : null,
        exitsFromFund: exitsFromFund != null ? String(exitsFromFund) : 'N/A',
        exitsFromFundMeta: computeExitRateMeta(exitsFromFund, totalPortfolioCompanies),
        stillActive: stillActivePercentage || 'N/A',
        stillActiveMeta: computeStillActiveMeta(stillActivePercentage, totalPortfolioCompanies),
    };

    const items = CARD_CONFIG.map((card) => ({
        key: card.key,
        label: card.label,
        displayValue: stats?.[card.key] || 'N/A',
        meta: stats?.[card.metaKey] || ' '
    }));

    return (
        <Highlights items={items} />
    )
};

export default InvestmentSummaryCards;
